import $ from 'jquery';
import Inputmask from 'inputmask';
import { BaseMask } from './base.mask';
import * as CONST from '../constants';
import masks from '../masks';
import { inputmaskFormat } from '../utils/inputmaskFormat';

const DEFINITIONS = {
    '#': { validator: '[0-9]', cardinality: 1, casing: 'lower' },
};

export class PhoneMask extends BaseMask {
    static getDefinitions() {
        return DEFINITIONS;
    }
    getClassConstructor() {
        return PhoneMask;
    }
    getConfig() {
        return CONST.PHONE_CONFIG;
    }
    getInvalidMsg() {
        return CONST.INVALID_PHONE_NUMBER_MSG;
    }

    getInvalidMsgAttr() {
        return CONST.INVALID_PHONE_MSG_DATA_ATTR;
    }

    isCountryAvailableForMask() {
        return true;
    }

    static maskMethod(value, element) {
        const $element = $(element);
        const im = $element.data('im');
        const $hintMessageBlock = $('span.phone-format');

        // if focused - skip validation
        if ($element.is(':focus')) {
            $element.removeClass('error');
            $element.siblings('.error-tooltip').addClass('hidden');
            $element.on('blur', () => {
                $element.siblings('.error-tooltip').removeClass('hidden');
            });
            $hintMessageBlock.removeClass('hidden');
            return true;
        }

        // if focused out - start validation
        // check if mask valid and complete
        if (im && ((!im.isComplete() || !im.isValid()))) {
            $element.addClass('error');
            $element.siblings('.error-tooltip').removeClass('hidden');
            $hintMessageBlock.addClass('hidden');
            return false;
        }

        $element.removeClass('error');
        $element.siblings('.error-tooltip').addClass('hidden');
        $hintMessageBlock.removeClass('hidden');
        return true;
    }

    static adjustView(countryCode, element) {
        const maskConfig = masks[countryCode.toUpperCase()].phone;
        const phone = $(element)
            .find(CONST.VIEW_MODE_PHONE_FIELD_SELECTOR)
            .text();
        let maskedPhone = '';
        if (maskConfig.mask) {
            maskedPhone = inputmaskFormat(
                phone,
                { mask: maskConfig.mask },
                PhoneMask.getDefinitions(),
            );
        } else if (maskConfig.regex) {
            maskedPhone = Inputmask.format(phone, {
                regex: maskConfig.regex,
            });
        }

        if (maskedPhone && maskedPhone.indexOf('_') <= 0) {
            $(element)
                .find(CONST.VIEW_MODE_PHONE_FIELD_SELECTOR)
                .html(maskedPhone);
        }
    }
}

PhoneMask.MASK_NAME = CONST.MASKED_PHONE_DEFINITION;
